module.exports = __webpack_public_path__ + "static/media/new_rieltor_bonus_mobile_x1.163c4990.png";